import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Users,
  CalendarCheck,
  UsersRound,
  UserX,
  Crown,
  Briefcase,
  Mic,
  MicOff,
  ChevronRight,
  ShieldOff,
} from "lucide-react";
import MasterPageShell from "../../components/masterData/MasterPageShell";
import { EMPTY_REPORT_FILTER, QUICK_REPORTS } from "./quickReport/quickReports";
import styles from "./QuickReport.module.scss";

const ICONS: Record<string, React.ReactNode> = {
  "full-list": <Users size={20} color="#285d8f" />,
  "last-two-years": <CalendarCheck size={20} color="#0369a1" />,
  "served-team": <UsersRound size={20} color="#15803d" />,
  "never-team": <UserX size={20} color="#b45309" />,
  "lead-couple": <Crown size={20} color="#6d28d9" />,
  "head-service": <Briefcase size={20} color="#c2410c" />,
  "never-head": <ShieldOff size={20} color="#b45309" />,
  "given-talk": <Mic size={20} color="#15803d" />,
  "never-talk": <MicOff size={20} color="#0369a1" />,
};

const QuickReport = (): JSX.Element => {
  const navigate = useNavigate();

  const openReport = (reportId: number, isNotHeadRole = "") => {
    navigate("/search_data", {
      state: {
        filter: { ...EMPTY_REPORT_FILTER },
        reportId,
        is_Not_Head_Role: isNotHeadRole,
      },
    });
  };

  return (
    <MasterPageShell>
      <div className={styles.page}>
        <div className={styles.grid}>
          {QUICK_REPORTS.map((report) => {
            const body = (
              <>
                <span className={styles.icon}>{ICONS[report.id]}</span>
                <span className={styles.copy}>
                  <p className={styles.label}>{report.label}</p>
                  <p className={styles.description}>{report.description}</p>
                  <span className={styles.openHint}>
                    Open <ChevronRight size={12} />
                  </span>
                </span>
                <ChevronRight size={16} className={styles.chevron} />
              </>
            );

            if (report.to) {
              return (
                <Link key={report.id} to={report.to} className={`${styles.card} ${styles[report.tone]}`}>
                  {body}
                </Link>
              );
            }

            return (
              <button
                key={report.id}
                type="button"
                className={`${styles.card} ${styles[report.tone]}`}
                onClick={() => openReport(report.reportId as number, report.isNotHeadRole || "")}
              >
                {body}
              </button>
            );
          })}
        </div>
      </div>
    </MasterPageShell>
  );
};

export default QuickReport;
